import * as React from 'react';

import {
	Card,
	Grid,
	Dialog,
	DialogContent,
	DialogActions,
	Menu,
	MenuItem,
	CardActions,
	Button,
	Typography,
	CardContent,
	CardActionArea,
	CardMedia,
	CardHeader,
	Box,
	Icon,
	TextField,
	Select,
	InputLabel,
	FormControl,
	Link,
	List,
	Tooltip,
} from '@material-ui/core';

import { displayLocalTime } from '../../util';
import { stores } from '../../store';
import { observer } from 'mobx-react-lite';
import { IFeedResultItems, ISiteObject } from '../../types';
import FeedWireFrame from '../../components/Feed/FeedWireframe';
import InfiniteScroll from 'react-infinite-scroll-component';
import useStyles from '../../assets/css/StatusFeedcss';
import VisitorImg from '../../assets/images/visitor.png';
import DeliveryImg from '../../assets/images/delivery.png';

import ReportProblemRounded from '@material-ui/icons/ReportProblemRounded';
import { Autocomplete } from '@material-ui/lab';
import SearchIcon from '@material-ui/icons/Search';
//import MonetizationOnRounded from '@material-ui/icons/MonetizationOnRounded';
import { faBadgeDollar, faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
const StatusFeeds: React.FunctionComponent = observer(() => {
	const feed = React.useContext(stores.context.feed);
	const user = React.useContext(stores.context.user);
	const classes = useStyles();
	const [pageNumber, setPageNumber] = React.useState(1);
	const [feedData, setFeedData] = React.useState<IFeedResultItems[]>([]);
	const [hasMore, setHasMore] = React.useState(true);
	const [feedDialogOpen, setFeedDialogOpen] = React.useState(false);
	const [opencardData, setOpenCardData] = React.useState<any>({});
	const [deliverySiteName, setDeliverySiteName] = React.useState<any>();
	const [srStatusDialogOpen, setSRStatuDialogOpen] = React.useState(false);
	const [disableButtons, setDisableButtons] = React.useState(false);
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
	//const [showApproverList, setShowApproverList] = React.useState(false);
	const [authoriserOptions, setAuthoriserOptions] = React.useState<any[]>([]);
	const [authoriserOptionsFull, setAuthoriserOptionsFull] = React.useState<any[]>([]);
	const [authoriserValue, setAuthoriserValue] = React.useState('');
	//const [showApproveDeclineList, setShowApproveDeclineList] = React.useState(false);
	const [reasonValue, setReasonValue] = React.useState('');
	const [approvalUserResponse, setApprovalUserResponse] = React.useState('');
	const [quoteApprovalUserResponse, setQuoteApprovalUserResponse] = React.useState('');
	const [quoteApprovalDialogOpen, setQuoteApprovalDialogOpen] = React.useState(false);
	const [quoteApprovalData, setQuoteApprovalData] = React.useState<any>({});
	const notifications = useContext(stores.context.notifications);
	const [userComments, setUserComments] = React.useState('');
	const site = React.useContext(stores.context.site);
	const routes: any = React.useContext(stores.context.routes);
	const [rejectlist, setrejectList] = React.useState<any[]>([]);
	const [reassignlist, setreassignList] = React.useState<any[]>([]);
	const [quoteDeclineMenuOpen, setQuoteDeclineMenuOpen] = React.useState(false);
	const firstMenuItemRef = React.useRef<HTMLLIElement>(null);
	React.useEffect(() => {
		const sitedatanew: any = localStorage.getItem('sitedatalat');
		const df: ISiteObject[] = sitedatanew ? JSON.parse(sitedatanew) : site.siteList;
		if (opencardData && opencardData.Parameters) {
			const deiliverySite = df.find(s => s.Id === opencardData.Parameters.SiteId[0]);
			setDeliverySiteName(deiliverySite);
		}
	}, [site.siteList, opencardData, opencardData.Parameters]);
	const statusHandleClickClose = () => {
		setSRStatuDialogOpen(false);
	};
	const fetchMoreData = () => {
		if (feedData.length >= feed.statusFeedItems && feed.statusFeedItems.Pagination.TotalFeedCount) {
			setHasMore(false);
			return;
		} else if (pageNumber === -1) {
			setHasMore(false);
			return;
		} else {
			feed.getStatusFeeds(pageNumber).then((resp: any) => {
				if (resp && resp.Result) {
					setFeedData([...feedData, ...resp.Result]);
					setPageNumber(resp && resp.Pagination.NextPageNumber);
				}
			});
		}
	};
	const feedHandleClickClose = () => {
		setDisableButtons(false);
		setApprovalUserResponse('');
		setUserComments('');
		setReasonValue('');
		setAuthoriserOptionsFull([]);
		setAuthoriserOptions([]);
		setAuthoriserValue('');
		setFeedDialogOpen(false);
		setQuoteApprovalData({});
		setQuoteApprovalDialogOpen(false);
		setQuoteApprovalUserResponse('');
		setQuoteDeclineMenuOpen(false);
	};

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget as HTMLButtonElement);
		setTimeout(() => {
			firstMenuItemRef.current?.focus();
		}, 0);
	};
	React.useEffect(() => {
		fetchStatusFeeds(1);
	}, []);
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleFeedDelayDelivery = (button: string, delaytime: number, id: any) => {
		feed.updateFeedStatus({
			feedId: id,
			ButtonName: button,
			State: { RemindMeInSeconds: delaytime },
		});
		setAnchorEl(null);
		feedHandleClickClose();
	};
	const handleFeedDelay = (button: string, delaytime: number, id: any) => {
		feed.updateFeedStatus({
			feedId: id,
			ButtonName: button,
			State: { RemindMeInSeconds: delaytime },
		});
		setAnchorEl(null);
		feedHandleClickClose();
	};
	const handleOpenCard = (
		title: string,
		time: string,
		description: string,
		parameters: any,
		category: number,
		id: number,
		buttons: any,
	) => {
		setDisableButtons(false);
		if (category === 2 || category === 3 || category === 13 || category === 14) {
			setFeedDialogOpen(true);
			setOpenCardData({
				Title: title,
				Description: description,
				StartTime: time,
				Parameters: parameters,
				Category: category,
				Id: id,
				AvailableButtons: buttons,
			});
		} else if (category === 8) {
			if (
				user.featurePermissions &&
				user.featurePermissions.JOB_REQUEST_CHAT &&
				user.modulePermissions &&
				user.modulePermissions.ASK
			) {
				routes.navigate({
					name: 'chatbot',
					params: {
						srId: parameters.SRNumber,
					},
				});
			} else {
				setSRStatuDialogOpen(true);
			}
		}
	};
	const fetchStatusFeeds = (pageNumber: Number) => {
		feed.getStatusFeeds(pageNumber).then((resp: any) => {
			if (resp && resp.Result) {
				setPageNumber(resp && resp.Pagination.NextPageNumber);
				setFeedData(resp.Result);
				if (resp && resp.Pagination.TotalFeedCount <= 6) {
					setHasMore(false);
				}
			}
		});
	};

	const fetchAuthorisers = (userInput: string) => {
		// minimum 3 characters required
		if (userInput.length > 2) {
			// reset values at every input
			setAuthoriserOptionsFull([]);
			setAuthoriserOptions([]);
			feed.getAuthorisers(userInput).then(authorisers => {
				if (authorisers.result.length > 0) {
					setAuthoriserOptionsFull(authorisers.result);
					setAuthoriserOptions(
						authorisers.result
							.filter((authoriser: any) => user.username.toLowerCase() != authoriser.EMAILADDRESS.toLowerCase())
							.map((authoriser: any) => {
								return authoriser.EMAILADDRESS;
							}),
					);
				}
			});
		}
	};

	const fetchReasons = () => {
		feed.getReasons().then(reasons => {
			let tempArrReject: any[] = [];
			let tempArrReassign: any[] = [];
			if (reasons.result.length > 0) {
				for (let i in reasons.result) {
					if (reasons.result[i].DOMAINID == 'MITREJECTREASONS') {
						tempArrReject.push(reasons.result[i]);
					} else if (reasons.result[i].DOMAINID == 'MITREASSIGNREASON') {
						tempArrReassign.push(reasons.result[i]);
					}

					setrejectList(tempArrReject);
					setreassignList(tempArrReassign);
				}
			}
		});
	};

	const handleTextChange = (event: React.ChangeEvent<any>) => {
		let userInput: any = event.target.value;

		setUserComments(userInput);
	};

	return (
		<>
			<div id="scrollableDivStatus" style={{ height: '100%', marginLeft: '8px', overflowY: 'scroll' }}>
				<InfiniteScroll
					dataLength={feedData.length}
					next={fetchMoreData}
					hasMore={hasMore}
					hasChildren={feed.statusFeedItemsCount <= feedData.length ? true : false}
					style={{ height: '100%', overflow: 'Hidden' }}
					loader={<FeedWireFrame feedType="statusfeed" />}
					endMessage={<p> </p>}
					scrollableTarget="scrollableDivStatus"
				>
					<Grid container spacing={2} direction="row" justify="flex-start" alignItems="flex-start">
						{feedData.map((elem: any) => (
							<Grid className={classes.feedAlignment} item xs={12} lg={12} md={12} key={feedData.indexOf(elem)}>
								{elem.Category === 1000 ? (
									<Card className={classes.wireframeCard}>
										<CardMedia
											component="img"
											height="140"
											image={elem.Parameters.MediaUrl}
											alt="green iguana"
											className={classes.statusFeed}
										/>
									</Card>
								) : (
									<Card className={classes.Card}>
										<CardActionArea
											classes={{
												root: classes.actionArea,
												focusHighlight: classes.focusHighlight,
											}}
											onClick={() => {
												handleOpenCard(
													elem.CollapsedTitle,
													elem.StartTime,
													elem.Description,
													elem.Parameters,
													elem.Category,
													elem.Id,
													elem.AvailableButtons,
												);
												fetchReasons();
											}}
											disableTouchRipple={true}
										>
											<CardHeader
												action={
													elem.Category === 13 ? (
														<div>
															<Icon aria-label="approve">
																<ReportProblemRounded />
															</Icon>
														</div>
													) : elem.Category === 14 ? (
														<div>
															<Icon aria-label="quote" style={{ fontSize: '1.3rem' }}>
																<FontAwesomeIcon icon={faBadgeDollar} />
															</Icon>
														</div>
													) : (
														''
													)
												}
												className={
													elem.Category === 13 || elem.Category === 14 ? classes.CardHeaderApproval : classes.CardHeader
												}
											></CardHeader>

											<CardContent>
												<Box display="flex" flexDirection="column" flexGrow={1}>
													<Box>
														<Box style={{ textAlign: 'start' }}>
															<Typography variant="subtitle1" className={classes.titleView}>
																{elem.CollapsedTitle}
															</Typography>
														</Box>
														<Box style={{ textAlign: 'end', marginTop: '-16px' }}>
															<Typography className={classes.timeView} variant="subtitle2">
																{displayLocalTime(elem.StartTime)}
															</Typography>
														</Box>
													</Box>
													<Box style={{ textAlign: 'start', marginTop: '6px' }}>
														{elem.Category === 1 ? (
															<>
																<Typography className={classes.subTitleView} variant="caption" color="textSecondary">
																	{elem.CollapsedDescription}
																</Typography>
																<Typography variant="subtitle1" style={{ marginTop: '6px' }}>
																	{elem.Description}
																</Typography>
															</>
														) : elem.Category === 3 ? (
															<>
																<Typography className={classes.subTitleView} variant="caption" color="textSecondary">
																	{'You have received a Delivery'}
																</Typography>
																<Typography
																	variant="subtitle1"
																	color="primary"
																	style={{
																		font: 'normal normal normal 14px/17px Roboto',
																		float: 'right',
																	}}
																>
																	{'Click here to confirm'}
																</Typography>
															</>
														) : elem.Category === 2 ? (
															<>
																<Typography className={classes.subTitleView} variant="caption" color="textSecondary">
																	{'A visitor has arrived'}
																</Typography>
																<Typography
																	variant="subtitle1"
																	color="primary"
																	style={{
																		font: 'normal normal normal 14px/17px Roboto',
																		float: 'right',
																	}}
																>
																	{'Click here to confirm'}
																</Typography>
															</>
														) : elem.Category === 13 ? (
															<>
																<Typography className={classes.subTitleView} variant="caption" color="textSecondary">
																	{elem.Parameters.LocationDescription}
																</Typography>
																<Typography
																	className={classes.subTitleView}
																	variant="caption"
																	color="textSecondary"
																	style={{
																		float: 'right',
																	}}
																>
																	<span style={{ color: '#002855' }}>Ref: </span>
																	{elem.ExternalData}
																</Typography>
																<Box margin={'2px 0 -2px -1px'}>
																	<Typography
																		className={classes.subTitleView}
																		variant="subtitle1"
																		style={{
																			display: 'inline',
																			color: '#002855',
																			minWidth: '35%',
																			textAlign: 'right',
																		}}
																	>
																		{elem.Parameters.IncidentName}
																	</Typography>
																	<Typography
																		variant="caption"
																		color="primary"
																		style={{
																			font: 'normal normal normal 14px/17px Roboto',
																			float: 'right',
																			marginTop: '6px',
																			minWidth: '35%',
																			textAlign: 'right',
																		}}
																	>
																		{'Click here to complete'}
																	</Typography>
																</Box>
															</>
														) : elem.Category === 14 ? (
															<>
																<Typography className={classes.subTitleView} variant="caption" color="textSecondary">
																	{elem.Parameters.LocationDescription}
																</Typography>
																<Typography
																	className={classes.subTitleView}
																	variant="caption"
																	color="textSecondary"
																	style={{
																		float: 'right',
																	}}
																>
																	<span style={{ color: '#002855' }}>Ref: </span>
																	{elem.ExternalData}
																</Typography>
																<Box margin={'2px 0 -2px -1px'}>
																	<Typography
																		className={classes.subTitleView}
																		variant="subtitle1"
																		style={{
																			display: 'inline',
																			color: '#002855',
																			minWidth: '35%',
																			textAlign: 'right',
																		}}
																	>
																		{elem.Parameters.IncidentName}
																	</Typography>
																	<Typography
																		variant="caption"
																		color="primary"
																		style={{
																			font: 'normal normal normal 14px/17px Roboto',
																			float: 'right',
																			marginTop: '6px',
																			minWidth: '35%',
																			textAlign: 'right',
																		}}
																	>
																		{'Click here to complete'}
																	</Typography>
																</Box>
															</>
														) : (
															<Typography className={classes.subTitleView} variant="caption" color="textSecondary">
																{elem.Description}
															</Typography>
														)}
													</Box>
												</Box>
											</CardContent>
										</CardActionArea>
									</Card>
								)}
							</Grid>
						))}
					</Grid>
				</InfiniteScroll>
			</div>
			<Dialog
				className={opencardData.Category === 14 ? classes.openCardDialogQuote : classes.openCardDialog}
				style={{ margin: 'auto', borderRadius: '8px' }}
				open={feedDialogOpen}
				onClose={feedHandleClickClose}
				scroll={'body'}
			>
				{opencardData.Category === 2 ? (
					<Card className={classes.openCard}>
						{opencardData.Parameters ? (
							<CardMedia
								component="img"
								height="140"
								image={VisitorImg}
								alt="Aria"
								style={{ height: '250px', objectFit: 'contain' }}
							/>
						) : (
							''
						)}
						<CardContent>
							<Box display="flex" flexDirection="column" flexGrow={1}>
								<Box>
									<Box style={{ textAlign: 'start' }}>
										<Typography variant="subtitle1" className={classes.openCardTitle}>
											{opencardData.Title}
										</Typography>
									</Box>
									<Box style={{ textAlign: 'end', marginTop: '-25px' }}>
										<Typography variant="subtitle1" className={classes.openCardTime}>
											{opencardData.StartTime ? displayLocalTime(opencardData.StartTime) : ''}
										</Typography>
									</Box>
								</Box>
								<Box
									display="flex"
									justifyContent="center"
									flexDirection="column"
									style={{
										textAlign: 'start',
										marginTop: '15px',
										marginLeft: '10px',
									}}
								>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'A visitor has arrived from:'}{' '}
										<b>{opencardData.Parameters && opencardData.Parameters.VisitorFromOrReasonForAttending}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Visitor Name:'} <b>{opencardData.Parameters && opencardData.Parameters.VisitorName}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'You can meet them at:'}{' '}
										<b>{opencardData.Parameters && opencardData.Parameters.CollectionPlace}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'At:'}
										{opencardData.Parameters && deliverySiteName ? deliverySiteName.Name : ''}
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										Please select from the following options
									</Typography>
								</Box>
							</Box>
						</CardContent>
						<CardActions className={classes.actions}>
							{opencardData &&
								opencardData.AvailableButtons.map((button: string) =>
									button === 'Not ready' ? (
										<div>
											<Button
												title={button}
												size="medium"
												key={button}
												className={classes.ActionButtons2}
												variant={button === 'Not ready' ? 'outlined' : 'contained'}
												onClick={handleClick}
											>
												{button}
											</Button>
											<Menu
												id="simple-menu"
												anchorEl={anchorEl}
												keepMounted
												open={Boolean(anchorEl)}
												onClose={handleClose}
											>
												<MenuItem className={classes.menuButton}>I will be there... </MenuItem>
												<MenuItem
													className={classes.menuButton2}
													onClick={() => handleFeedDelay(button, 300, opencardData.Id)}
												>
													In 5 minutes
												</MenuItem>
												<MenuItem
													className={classes.menuButton2}
													onClick={() => handleFeedDelay(button, 600, opencardData.Id)}
												>
													In 10 minutes
												</MenuItem>
												<MenuItem
													className={classes.menuButton2}
													onClick={() => handleFeedDelay(button, 900, opencardData.Id)}
												>
													In 15 minutes
												</MenuItem>
											</Menu>
										</div>
									) : (
										<Button
											title={button}
											size="medium"
											key={button}
											className={classes.ActionButtons}
											variant={button === 'Not ready' ? 'outlined' : 'contained'}
											disabled={disableButtons}
											onClick={() => {
												feed.updateFeedStatus({
													feedId: opencardData.Id,
													ButtonName: button,
													State: null,
												});
												feedHandleClickClose();
											}}
										>
											{button}
										</Button>
									),
								)}
						</CardActions>
					</Card>
				) : opencardData.Category === 3 ? (
					<Card className={classes.openCard}>
						{opencardData.Parameters ? (
							<CardMedia
								component="img"
								height="140"
								image={DeliveryImg}
								alt="Aria"
								style={{ height: '250px', objectFit: 'contain' }}
							/>
						) : (
							''
						)}
						<CardContent>
							<Box display="flex" flexDirection="column" flexGrow={1}>
								<Box>
									<Box style={{ textAlign: 'start' }}>
										<Typography variant="subtitle1" className={classes.openCardTitle}>
											{opencardData.Title}
										</Typography>
									</Box>
									<Box style={{ textAlign: 'end', marginTop: '-25px' }}>
										<Typography variant="subtitle1" className={classes.openCardTime}>
											{opencardData.StartTime ? displayLocalTime(opencardData.StartTime) : ''}
										</Typography>
									</Box>
								</Box>
								<Box
									display="flex"
									justifyContent="center"
									flexDirection="column"
									style={{
										textAlign: 'start',
										marginTop: '15px',
										marginLeft: '10px',
									}}
								>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'A delivery has arrived from:'}{' '}
										<b>{opencardData.Parameters && opencardData.Parameters.SenderName}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Parcel Number:'} <b>{opencardData.Parameters && opencardData.Parameters.ParcelNumber}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'You can collect the item from:'}{' '}
										<b>{opencardData.Parameters && opencardData.Parameters.CollectionPlace}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'At:'}
										{opencardData.Parameters && deliverySiteName ? deliverySiteName.Name : ''}
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										Please select from the following options
									</Typography>
								</Box>
							</Box>
						</CardContent>
						<CardActions className={classes.actions}>
							{opencardData &&
								opencardData.AvailableButtons.map((button: string) =>
									button === 'Hold on to it' ? (
										<div key={button}>
											<Button
												title={button}
												size="medium"
												color="primary"
												key={button}
												aria-controls="simple-menu"
												aria-haspopup="false"
												variant={button === 'Hold on to it' ? 'outlined' : 'contained'}
												onClick={handleClick}
												className={classes.ActionButtons2}
												style={{ marginTop: '16px' }}
											>
												{button}
											</Button>
											<Menu
												id="simple-menu"
												anchorEl={anchorEl}
												keepMounted
												open={Boolean(anchorEl)}
												onClose={handleClose}
											>
												<MenuItem ref={firstMenuItemRef} className={classes.menuButton}>
													Remind me in...
												</MenuItem>
												<MenuItem
													className={classes.menuButton2}
													onClick={() => handleFeedDelayDelivery(button, 3600, opencardData.Id)}
												>
													1 hour
												</MenuItem>
												<MenuItem
													className={classes.menuButton2}
													onClick={() => handleFeedDelayDelivery(button, 7200, opencardData.Id)}
												>
													2 hours
												</MenuItem>
												<MenuItem
													className={classes.menuButton2}
													onClick={() => handleFeedDelayDelivery(button, 14400, opencardData.Id)}
												>
													4 hours
												</MenuItem>
												<MenuItem
													className={classes.menuButton2}
													onClick={() => handleFeedDelayDelivery(button, 0, opencardData.Id)}
												>
													Don't remind
												</MenuItem>
											</Menu>
										</div>
									) : (
										<Button
											title={button}
											size="medium"
											color="primary"
											key={button}
											className={classes.ActionButtons}
											variant={button === 'Hold on to it' ? 'outlined' : 'contained'}
											disabled={disableButtons}
											onClick={() => {
												feed.updateFeedStatus({
													feedId: opencardData.Id,
													ButtonName: button,
													State: null,
												});
												feedHandleClickClose();
											}}
										>
											{button}
										</Button>
									),
								)}
						</CardActions>
					</Card>
				) : opencardData.Category === 13 ? (
					<Card className={classes.openCard}>
						<CardHeader className={classes.CardHeader}></CardHeader>
						<CardContent>
							<Box display="flex" flexDirection="column" flexGrow={1}>
								<Box style={{ marginBottom: '4px' }}>
									<Box style={{ textAlign: 'start' }}>
										<Typography
											variant="subtitle1"
											style={{
												paddingLeft: '8px',
											}}
											className={classes.openCardTitle}
										>
											{opencardData.Title}
										</Typography>
									</Box>
									<Box style={{ textAlign: 'end', marginTop: '-25px', paddingRight: '8px' }}>
										<Typography variant="subtitle1" className={classes.openCardTime}>
											{opencardData.StartTime ? displayLocalTime(opencardData.StartTime) : ''}
										</Typography>
									</Box>
								</Box>

								<Box
									display="flex"
									justifyContent="center"
									flexDirection="column"
									style={{
										textAlign: 'start',
										marginTop: '15px',
										marginLeft: '20px',
									}}
								>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Approval has been requested for:'}{' '}
										<b>{opencardData.Parameters && opencardData.Parameters.LocationDescription}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Requestor Name:'} <b>{opencardData.Parameters && opencardData.Parameters.RequestorName}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Service Request:'} <b>{opencardData.Parameters && opencardData.Parameters.TicketId}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Further Details:'} <b>{opencardData.Parameters && opencardData.Parameters.IncidentName}</b>
									</Typography>

									{opencardData.Parameters && opencardData.Parameters.Costcode ? (
										<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
											{'Cost Code:'} <b>{opencardData.Parameters.Costcode}</b>
										</Typography>
									) : (
										''
									)}
									{/* <Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Request No:'}
										<b>{opencardData.Parameters.TicketId}</b>
									</Typography> */}
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										<Link
											className={classes.openCardTypography}
											variant="body2"
											href="#"
											style={{ color: '#007DBA' }}
											onClick={() => {
												routes.navigate(
													{
														name: 'chatbot',
														params: {
															srId: opencardData.Parameters.TicketId,
															jobApproval: true,
														},
													},
													{
														clearParams: true,
													},
												);
											}}
										>
											View more details
										</Link>
									</Typography>
								</Box>
							</Box>
						</CardContent>
						<CardActions className={classes.actions} style={{ marginRight: '16px', paddingBottom: '0px' }}>
							{approvalUserResponse === '' ? (
								<Button
									title="Close"
									size="small"
									onClick={feedHandleClickClose}
									aria-controls="simple-menu"
									style={{ paddingRight: '8px', alignSelf: 'end', color: '#007DBA', marginRight: 'auto' }}
								>
									Close
								</Button>
							) : null}

							{opencardData &&
								opencardData.AvailableButtons.map((button: string) => (
									<Button
										title={button}
										size="medium"
										key={button}
										variant={approvalUserResponse === button ? 'contained' : 'outlined'}
										className={approvalUserResponse === button ? classes.ActionButtons : classes.cancelbtn}
										style={{ marginTop: '15px' }}
										disabled={disableButtons}
										onClick={() => {
											setApprovalUserResponse(button);
											setReasonValue('');
										}}
									>
										{button}
									</Button>
								))}
						</CardActions>
						<CardContent style={{ marginLeft: '8px', paddingBottom: '0px', marginRight: '16px' }}>
							{approvalUserResponse === 'Reassign' || approvalUserResponse === 'Decline' ? (
								<>
									{approvalUserResponse === 'Reassign' ? (
										<Box
											display="flex"
											flexDirection="column"
											style={{ marginLeft: '5px', marginTop: '0px' }}
											flexGrow={1}
										>
											<Typography
												className={classes.openCardTypographyLabelInput}
												variant="body2"
												style={{ paddingLeft: '10px', marginBottom: '2px!important' }}
												gutterBottom
											>
												Please locate the user you would like to reassign this to:
											</Typography>
											<Autocomplete
												disableClearable
												className={classes.AutoComplete1}
												classes={{
													option: classes.option,
												}}
												popupIcon={<SearchIcon />}
												filterOptions={x => x}
												options={authoriserOptions}
												size="small"
												id="combo-box-demo"
												noOptionsText="Loading..."
												value={authoriserValue}
												onChange={(event: any, newValue: string | '') => {
													setAuthoriserValue(newValue);
												}}
												onInputChange={(event, newInputValue) => {
													if (!newInputValue) {
														setAuthoriserOptions([]);
													} else {
														fetchAuthorisers(newInputValue);
													}
												}}
												renderInput={(params: any) => (
													// <Tooltip title="Minimum 3 characters required" placement="top-start">
													<TextField
														{...params}
														label="Approver name or Email"
														variant="outlined"
														fullWidth
														margin="normal"
													/>
													// </Tooltip>
												)}
											/>
										</Box>
									) : null}

									<Box
										display="flex"
										flexDirection="column"
										flexGrow={1}
										style={{ marginLeft: '0px', paddingTop: '4px' }}
									>
										<Typography
											style={{ paddingLeft: '14px', paddingBottom: '8px', paddingTop: '4px' }}
											className={classes.openCardTypographyLabelInput}
											variant="body2"
											gutterBottom
										>
											Please provide a reason for your selection:
										</Typography>
										<FormControl
											variant="filled"
											fullWidth
											className={classes.formControl}
											style={{ marginLeft: '0px', marginTop: '0px', paddingLeft: '4px' }}
										>
											<InputLabel id="reasons-select-label" className={reasonValue ? classes.formControlLabel : ''}>
												Reason
											</InputLabel>
											<Select
												labelId="reasons-select-label"
												id="reasons-select"
												name="reasons"
												onClose={handleClose}
												value={reasonValue}
												label="Reasons"
												disableUnderline={true}
												className={classes.formSelect}
												MenuProps={{
													getContentAnchorEl: null,
													anchorOrigin: {
														vertical: 'bottom',
														horizontal: 'left',
													},
												}}
												onChange={(event: any) => {
													setReasonValue(event.target.value);
												}}
											>
												{approvalUserResponse === 'Decline' && rejectlist.length > 0
													? rejectlist.map((n: any) => (
															<MenuItem key={n.VALUE} value={n.VALUE}>
																{n.DESCRIPTION}
															</MenuItem>
													  ))
													: null}
												{approvalUserResponse === 'Reassign' && reassignlist.length > 0
													? reassignlist.map((n: any) => (
															<MenuItem key={n.VALUE} value={n.VALUE}>
																{n.DESCRIPTION}
															</MenuItem>
													  ))
													: null}
											</Select>
										</FormControl>
										{reasonValue.toLowerCase() === 'other' ? (
											<Typography className={classes.openCardTypographyLabelInput} variant="body2" gutterBottom>
												<TextField
													variant="outlined"
													placeholder="Write your message here"
													multiline
													rows={4}
													fullWidth
													defaultValue={userComments}
													inputProps={{ maxLength: 140 }}
													onChange={e => setUserComments(e.target.value)}
													style={{ marginLeft: '3px', marginTop: '0px', paddingRight: '3px' }}
													className={classes.InputField}
												/>

												{userComments.length > 0 ? ` - ${140 - userComments.length} remaining` : ''}
											</Typography>
										) : null}
									</Box>
								</>
							) : approvalUserResponse === 'Approve' ? (
								<Box>
									<Typography
										className={classes.openCardTypographyLabelInput}
										variant="body2"
										style={{ paddingLeft: '8px' }}
										gutterBottom
									>
										<div style={{ paddingBottom: '12px' }}>
											<span style={{ paddingLeft: '14px' }}>You can comment below (optional)</span>
										</div>
										<TextField
											variant="outlined"
											placeholder="Enter your comment here"
											multiline
											rows={4}
											fullWidth
											inputProps={{ maxLength: 140 }}
											onChange={handleTextChange}
											style={{ marginLeft: '8px', marginTop: '0px', paddingRight: '24px' }}
										/>

										{userComments.length > 0 ? ` - ${140 - userComments.length} remaining` : ''}
									</Typography>
								</Box>
							) : (
								''
							)}
						</CardContent>
						{approvalUserResponse ? (
							<CardActions className={classes.actions} style={{ marginRight: '16px' }}>
								<Button
									title="Cancel"
									size="medium"
									key="cancel"
									aria-controls="simple-menu"
									aria-haspopup="false"
									variant="outlined"
									onClick={feedHandleClickClose}
									className={classes.cancelbtn}
									disabled={disableButtons}
									style={{ float: 'right', marginTop: '10px' }}
								>
									Cancel
								</Button>

								<Button
									title="Send"
									size="medium"
									key="send"
									aria-controls="simple-menu"
									aria-haspopup="false"
									variant="contained"
									onClick={() => {
										setDisableButtons(true);
										let authoriserPersonId;
										if (approvalUserResponse === 'Reassign') {
											authoriserPersonId = authoriserOptionsFull.find(a => a.EMAILADDRESS == authoriserValue)
												.MITCAPERSONID;
										}

										feed
											.updateFeedStatus({
												feedId: opencardData.Id,
												ButtonName: approvalUserResponse,
												State: {
													authoriserEmail: authoriserValue,
													text: userComments,
													authoriserPersonId: authoriserPersonId,
													reason: reasonValue,
												},
											})
											.then(() => {
												//re-load feeds from the server
												fetchStatusFeeds(1);
												feedHandleClickClose();
											});
									}}
									className={classes.ActionButtons}
									style={{ float: 'right', marginTop: '9px', width: '64px' }}
									disabled={
										(approvalUserResponse === 'Approve'
											? false
											: !reasonValue
											? true
											: approvalUserResponse === 'Reassign' && !authoriserValue
											? true
											: reasonValue.toLowerCase() === 'other' && userComments.length == 0
											? true
											: false) || disableButtons
									}
								>
									Send
								</Button>
							</CardActions>
						) : null}
					</Card>
				) : opencardData.Category === 14 ? (
					<Card className={classes.openCard}>
						<CardHeader className={classes.CardHeader}></CardHeader>
						<CardContent>
							<Box display="flex" flexDirection="column" flexGrow={1}>
								<Box style={{ marginBottom: '4px' }}>
									<Box style={{ textAlign: 'start' }}>
										<Typography
											variant="subtitle1"
											style={{
												paddingLeft: '8px',
											}}
											className={classes.openCardTitle}
										>
											{opencardData.Title}
										</Typography>
									</Box>
									<Box style={{ textAlign: 'end', marginTop: '-25px', paddingRight: '8px' }}>
										<Typography variant="subtitle1" className={classes.openCardTime}>
											{opencardData.StartTime ? displayLocalTime(opencardData.StartTime) : ''}
										</Typography>
									</Box>
								</Box>

								<Box
									display="flex"
									justifyContent="center"
									flexDirection="column"
									style={{
										textAlign: 'start',
										marginTop: '15px',
										marginLeft: '20px',
									}}
								>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Quote Approval has been requested for:'}{' '}
										<b>{opencardData.Parameters && opencardData.Parameters.LocationDescription}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Requestor Name:'} <b>{opencardData.Parameters && opencardData.Parameters.RequestorName}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Service Request:'} <b>{opencardData.Parameters && opencardData.Parameters.TicketId}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Further Details:'} <b>{opencardData.Parameters && opencardData.Parameters.IncidentName}</b>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										<Link
											className={classes.openCardTypography}
											variant="body2"
											href="#"
											style={{ color: '#007DBA' }}
											onClick={() => {
												routes.navigate(
													{
														name: 'chatbot',
														params: {
															srId: opencardData.Parameters.TicketId,
															jobApproval: true,
														},
													},
													{
														clearParams: true,
													},
												);
											}}
										>
											View more details
										</Link>
									</Typography>
									<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										<b>Please select a quote from the following options:</b>
									</Typography>

									{opencardData.Parameters && opencardData.Parameters.Costcode ? (
										<Typography className={classes.openCardTypography} variant="body2" gutterBottom>
											{'Cost Code:'} <b>{opencardData.Parameters.Costcode}</b>
										</Typography>
									) : (
										''
									)}
									{/* <Typography className={classes.openCardTypography} variant="body2" gutterBottom>
										{'Request No:'}
										<b>{opencardData.Parameters.TicketId}</b>
									</Typography> */}
									<List
										style={{
											marginTop: 20,
											//background: '#F4F8FC',
											borderRadius: 5,
											marginBottom: 10,
										}}
									>
										{opencardData.Parameters.WorkOrders &&
											opencardData.Parameters.WorkOrders.map((workOrder: any) => (
												<>
													<Card
														variant="outlined"
														style={{
															marginTop: '10px',
															borderRadius: 16,
															marginLeft: '10px',
															marginRight: '10px',

															boxShadow: '0px 3px 6px #00000029',
															opacity: '1',
														}}
													>
														<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
															<Typography variant="body2" style={{ padding: 15, color: '#002855', fontSize: '16px' }}>
																Quote: {workOrder.Wonum}
															</Typography>
															<Typography
																color="textSecondary"
																style={{
																	marginLeft: 'auto',
																	padding: 15,
																	paddingBottom: 0,
																	color: '#002855',
																	fontSize: '16px',
																	fontWeight: 'bold',
																}}
																variant="body2"
															>
																Value: {workOrder.Currency == 'GBP' ? `£${workOrder.Value || 0}` : workOrder.Value || 0}
																{''}
															</Typography>
														</Box>

														<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
															<Typography
																variant="body2"
																style={{ paddingLeft: 15, paddingBottom: 0, color: '#002855', fontSize: '16px' }}
															>
																Quote details:{' '}
																<span style={{ color: '#565A5C' }}>
																	{workOrder.Description ? workOrder.Description : ''}
																</span>
															</Typography>
														</Box>

														<Box display="flex" flexDirection="row" mt={2} style={{ paddingBottom: 15, marginTop: 0 }}>
															{workOrder.Doclinks && workOrder.Doclinks.length > 0 ? (
																<Typography
																	variant="body2"
																	style={{
																		float: 'left',
																		padding: 15,
																		paddingBottom: 0,
																		color: '#002855',
																		fontSize: '16px',
																	}}
																>
																	<>
																		Supporting documents:&nbsp;
																		{workOrder.Doclinks &&
																			workOrder.Doclinks.map((doclink: any, index: number) => (
																				<>
																					<Tooltip title={doclink.Filename}>
																						<Link
																							href={doclink.Url}
																							target="_blank"
																							style={{ color: '#007DBA', padding: 0 }}
																						>
																							{doclink.Description}&nbsp;
																						</Link>
																					</Tooltip>
																					{index % 2 == 1 ? <br /> : null}
																				</>
																			))}
																	</>
																</Typography>
															) : null}
															<Typography
																color="textSecondary"
																style={{ marginLeft: 'auto', paddingRight: 10 }}
																variant="body2"
															>
																{quoteApprovalData.Wonum === workOrder.Wonum ? (
																	<div style={{ color: '#00A246', paddingTop: '15px' }}>
																		Accept
																		<FontAwesomeIcon icon={faCheckCircle} />
																	</div>
																) : null}

																{quoteApprovalUserResponse == 'Decline All' ||
																(quoteApprovalData.Wonum && quoteApprovalData.Wonum != workOrder.Wonum) ? (
																	<div style={{ color: '#D71920', paddingTop: '15px' }}>
																		Decline
																		<FontAwesomeIcon icon={faTimesCircle} />
																	</div>
																) : null}
															</Typography>

															<Typography color="textSecondary" variant="body2">
																<Button
																	title="Approve quote"
																	size="medium"
																	key="Approve quote"
																	variant="contained"
																	className={classes.ActionButtonsQuote}
																	style={{ marginTop: '10px' }}
																	disabled={quoteApprovalData.Wonum == workOrder.Wonum}
																	onClick={() => {
																		setQuoteApprovalData(workOrder);
																	}}
																>
																	Approve quote
																</Button>
															</Typography>
														</Box>
													</Card>
												</>
											))}
									</List>
								</Box>
							</Box>
						</CardContent>
						<CardActions className={classes.actions} style={{ marginRight: '16px', paddingBottom: '16px' }}>
							<Button
								title="Close"
								size="small"
								className={classes.closebtn}
								onClick={feedHandleClickClose}
								aria-controls="simple-menu"
								style={{ paddingRight: '8px', alignSelf: 'end', color: '#007DBA', marginRight: 'auto' }}
							>
								Close
							</Button>

							{opencardData &&
								opencardData.AvailableButtons.map((button: string) => (
									<Button
										title={button}
										size="medium"
										key={button}
										variant={button == 'Confirm' ? 'contained' : 'outlined'}
										className={button == 'Confirm' ? classes.ActionButtonsQuote : classes.cancelbtnQuote}
										style={{ marginTop: '15px', display: button == 'Approve Quote' ? 'none' : '' }}
										onClick={() => {
											setQuoteApprovalUserResponse(button);
											setQuoteApprovalDialogOpen(true);
											if (button == 'Decline All') {
												setQuoteApprovalData({});
											}
											if (button == 'Query') {
												setReasonValue('Other');
											}
										}}
										disabled={(!quoteApprovalData.Wonum && button == 'Confirm') || disableButtons}
									>
										{button}
									</Button>
								))}
						</CardActions>
					</Card>
				) : (
					''
				)}
			</Dialog>

			<Dialog
				style={{ margin: 'auto', borderRadius: '8px' }}
				open={quoteApprovalDialogOpen}
				onClose={statusHandleClickClose}
				scroll={'paper'}
			>
				<DialogContent>
					<Box display="flex" flexDirection="column" flexGrow={1}>
						<Box>
							<Box style={{ textAlign: 'start' }}>
								{quoteApprovalUserResponse == 'Decline All' ? (
									<>
										<Typography variant="h6" className={classes.openCardTitle}>
											Decline all quotes
										</Typography>

										<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
											<Typography variant="body2" style={{ padding: 15, color: '#002855', fontSize: '14px' }}>
												Please confirm that you would like to decline all quotes suggested for this request. The request
												will not be progressed further.
											</Typography>
										</Box>

										<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
											<Typography variant="body2" style={{ padding: 15, color: '#002855', fontSize: '14px' }}>
												Please provide a reason for declining these quotes:
											</Typography>
										</Box>
										<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
											<FormControl
												variant="filled"
												fullWidth
												className={quoteDeclineMenuOpen ? classes.formControl : classes.formControlQuote}
												style={{ marginLeft: '0px', marginTop: '0px', paddingLeft: '4px' }}
											>
												<InputLabel id="reasons-select-label" className={reasonValue ? classes.formControlLabel : ''}>
													Reason
												</InputLabel>
												<Select
													labelId="reasons-select-label"
													id="reasons-select"
													name="reasons"
													value={reasonValue}
													label="Reasons"
													disableUnderline={true}
													className={quoteDeclineMenuOpen ? classes.formSelectQuote : classes.formSelect}
													MenuProps={{
														getContentAnchorEl: null,
														anchorOrigin: {
															vertical: 'bottom',
															horizontal: 'left',
														},
													}}
													onChange={(event: any) => {
														setReasonValue(event.target.value);
														setQuoteDeclineMenuOpen(false);
													}}
													onOpen={(event: any) => {
														setQuoteDeclineMenuOpen(true);
													}}
													onClose={(event: any) => {
														setQuoteDeclineMenuOpen(false);
														handleClose();
													}}
												>
													{rejectlist.length > 0
														? rejectlist.map((n: any) => (
																<MenuItem key={n.VALUE} value={n.VALUE}>
																	{n.DESCRIPTION}
																</MenuItem>
														  ))
														: null}
												</Select>
											</FormControl>
										</Box>
										{reasonValue.toLowerCase() === 'other' ? (
											<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
												<TextField
													variant="outlined"
													placeholder="Write your message here"
													multiline
													rows={4}
													fullWidth
													defaultValue={userComments}
													inputProps={{ maxLength: 140 }}
													onChange={e => setUserComments(e.target.value)}
													style={{ marginLeft: '3px', marginTop: '0px', paddingRight: '3px' }}
													className={classes.InputField}
												/>

												{userComments.length > 0 ? ` - ${140 - userComments.length} remaining` : ''}
											</Box>
										) : null}
									</>
								) : quoteApprovalUserResponse === 'Query' ? (
									<>
										<Typography variant="h3" style={{ paddingBottom: 15 }} className={classes.openCardTitle}>
											Query Quotes
										</Typography>
										<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
											<Typography variant="body2" style={{ padding: 15, color: '#002855', fontSize: '14px' }}>
												Please confirm that you would like to query all quotes suggested for this request. The request
												will not be progressed further.
											</Typography>
										</Box>
										{/*
											<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
												<Typography variant="body2" style={{ padding: 15, color: '#002855', fontSize: '14px' }}>
													Please provide a reason for quering these quotes:
												</Typography>
											</Box>
											<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
												<FormControl
													variant="filled"
													fullWidth
													className={quoteDeclineMenuOpen ? classes.formControl : classes.formControlQuote}
													style={{ marginLeft: '0px', marginTop: '0px', paddingLeft: '4px' }}
												>
													<InputLabel id="reasons-select-label">Reason</InputLabel>
													<Select
														labelId="reasons-select-label"
														id="reasons-select"
														name="reasons"
														value={reasonValue}
														label="Reasons"
														disableUnderline={true}
														className={quoteDeclineMenuOpen ? classes.formSelectQuote : classes.formSelect}
														defaultValue= {reasonValue}
														MenuProps={{
															getContentAnchorEl: null,
															anchorOrigin: {
																vertical: 'bottom',
																horizontal: 'left',
															},
														}}
														onChange={(event: any) => {
															setReasonValue(event.target.value);
															setQuoteDeclineMenuOpen(false);
														}}
														onOpen={(event: any) => {
															setQuoteDeclineMenuOpen(true);
														}}
														onClose={(event: any) => {
															setQuoteDeclineMenuOpen(false);
															handleClose();
														}}
													>
														{rejectlist.length > 0
															? rejectlist.map((n: any) => (
																<MenuItem key={n.VALUE} value={n.VALUE}>
																	{n.DESCRIPTION}
																</MenuItem>
															))
															: null}
													</Select>
												</FormControl>
											</Box>
											*/}
										{reasonValue.toLowerCase() === 'other' ? (
											<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
												<TextField
													variant="outlined"
													placeholder="Write your message here"
													multiline
													rows={4}
													fullWidth
													defaultValue={userComments}
													inputProps={{ maxLength: 140 }}
													onChange={e => setUserComments(e.target.value)}
													style={{ marginLeft: '3px', marginTop: '0px', paddingRight: '3px' }}
													className={classes.InputField}
												/>

												{userComments.length > 0 ? ` - ${140 - userComments.length} remaining` : ''}
											</Box>
										) : null}
									</>
								) : quoteApprovalUserResponse === 'Reassign' ? (
									<>
										<Typography variant="h3" style={{ paddingBottom: 15 }} className={classes.openCardTitle}>
											Reassign Quote
										</Typography>

										<Box
											display="flex"
											flexDirection="column"
											style={{ marginLeft: '5px', marginTop: '0px' }}
											flexGrow={1}
										>
											<Typography
												className={classes.openCardTypographyLabelInput}
												variant="body2"
												style={{ paddingLeft: '10px', marginBottom: '2px!important' }}
												gutterBottom
											>
												You are reassigning quote for approval, please locate the user you would like to reassign this
												to:
											</Typography>
											<Autocomplete
												disableClearable
												className={classes.AutoComplete1}
												classes={{
													option: classes.option,
												}}
												popupIcon={<SearchIcon />}
												filterOptions={x => x}
												options={authoriserOptions}
												size="small"
												id="combo-box-demo"
												noOptionsText="Loading..."
												value={authoriserValue}
												onChange={(event: any, newValue: string | '') => {
													setAuthoriserValue(newValue);
												}}
												onInputChange={(event, newInputValue) => {
													if (!newInputValue) {
														setAuthoriserOptions([]);
													} else {
														fetchAuthorisers(newInputValue);
													}
												}}
												renderInput={(params: any) => (
													// <Tooltip title="Minimum 3 characters required" placement="top-start">
													<TextField
														{...params}
														label="Approver name or Email"
														variant="outlined"
														fullWidth
														margin="normal"
													/>
													// </Tooltip>
												)}
											/>
										</Box>

										<Box
											display="flex"
											flexDirection="column"
											flexGrow={1}
											style={{ marginLeft: '0px', paddingTop: '4px' }}
										>
											<Typography
												style={{ paddingLeft: '14px', paddingBottom: '8px', paddingTop: '4px' }}
												className={classes.openCardTypographyLabelInput}
												variant="body2"
												gutterBottom
											>
												Please provide a reason for your selection:
											</Typography>
											<FormControl
												variant="filled"
												fullWidth
												className={classes.formControl}
												style={{ marginLeft: '0px', marginTop: '0px', paddingLeft: '4px' }}
											>
												<InputLabel id="reasons-select-label" className={reasonValue ? classes.formControlLabel : ''}>
													Reason
												</InputLabel>
												<Select
													labelId="reasons-select-label"
													id="reasons-select"
													name="reasons"
													onClose={handleClose}
													value={reasonValue}
													label="Reasons"
													disableUnderline={true}
													className={classes.formSelect}
													MenuProps={{
														getContentAnchorEl: null,
														anchorOrigin: {
															vertical: 'bottom',
															horizontal: 'left',
														},
													}}
													onChange={(event: any) => {
														setReasonValue(event.target.value);
													}}
												>
													{reassignlist.length > 0
														? reassignlist.map((n: any) => (
																<MenuItem key={n.VALUE} value={n.VALUE}>
																	{n.DESCRIPTION}
																</MenuItem>
														  ))
														: null}
												</Select>
											</FormControl>
											{reasonValue.toLowerCase() === 'other' ? (
												<Typography className={classes.openCardTypographyLabelInput} variant="body2" gutterBottom>
													<TextField
														variant="outlined"
														placeholder="Write your message here"
														multiline
														rows={4}
														fullWidth
														defaultValue={userComments}
														inputProps={{ maxLength: 140 }}
														onChange={e => setUserComments(e.target.value)}
														style={{ marginLeft: '3px', marginTop: '0px', paddingRight: '3px' }}
														className={classes.InputField}
													/>

													{userComments.length > 0 ? ` - ${140 - userComments.length} remaining` : ''}
												</Typography>
											) : null}
										</Box>
									</>
								) : (
									<>
										<Typography variant="h3" style={{ paddingBottom: 15 }} className={classes.openCardTitle}>
											Quote confirmation
										</Typography>
										<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
											<Typography variant="body2" style={{ paddingLeft: 15, color: '#002855', fontSize: '14px' }}>
												Please confirm that you would like to accept the quote.
											</Typography>
										</Box>
										<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
											<Typography
												variant="body2"
												style={{ paddingLeft: 15, color: '#002855', fontSize: '14px', fontWeight: 'bold' }}
											>
												Value:{' '}
												{quoteApprovalData.Currency == 'GBP' ? `£${quoteApprovalData.Value}` : quoteApprovalData.Value}
												{''}
											</Typography>
										</Box>
										<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
											<Typography variant="body2" style={{ paddingLeft: 15, color: '#002855', fontSize: '14px' }}>
												Quote: {quoteApprovalData.Wonum}
											</Typography>
										</Box>
										<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
											<Typography variant="body2" style={{ padding: 15, color: '#002855', fontSize: '14px' }}>
												Accepting this quote will decline all other quotes against this request.
											</Typography>
										</Box>
									</>
								)}
							</Box>
						</Box>
					</Box>
				</DialogContent>
				<DialogActions className={classes.actions}>
					{quoteApprovalUserResponse == 'Decline All' ||
					quoteApprovalUserResponse == 'Query' ||
					quoteApprovalUserResponse == 'Reassign' ? (
						<>
							<Button
								title="Cancel"
								size="medium"
								variant="outlined"
								className={classes.cancelbtn}
								style={{ marginTop: '15px' }}
								disabled={disableButtons}
								onClick={() => {
									setQuoteApprovalDialogOpen(false);
									setQuoteApprovalData({});
									setQuoteApprovalUserResponse('');
									setReasonValue('');
									setUserComments('');
									setAuthoriserValue('');
								}}
							>
								Cancel
							</Button>
							<Button
								title="Confirm"
								size="medium"
								variant="contained"
								key="confirm"
								className={classes.ActionButtonsQuote}
								style={{ marginTop: '15px', color: '#ffffff !important' }}
								disabled={
									(!reasonValue
										? true
										: quoteApprovalUserResponse === 'Reassign' && !authoriserValue
										? true
										: reasonValue.toLowerCase() === 'other' && userComments.length == 0
										? true
										: false) || disableButtons
								}
								onClick={() => {
									setDisableButtons(true);
									let authoriserPersonId;
									if (quoteApprovalUserResponse === 'Reassign') {
										authoriserPersonId = authoriserOptionsFull.find(a => a.EMAILADDRESS == authoriserValue)
											.MITCAPERSONID;
									}

									feed
										.updateFeedStatus({
											feedId: opencardData.Id,
											ButtonName: quoteApprovalUserResponse,
											State: {
												authoriserEmail: authoriserValue,
												text: userComments,
												authoriserPersonId: authoriserPersonId,
												reason: reasonValue,
											},
										})
										.then(resp => {
											//re-load feeds from the server
											fetchStatusFeeds(1);
											setQuoteApprovalDialogOpen(false);
											feedHandleClickClose();
											if (resp != undefined) notifications.addNotification(resp, 'error');
										})
										.catch(() => {
											feedHandleClickClose();
											notifications.addNotification('Error updating request', 'error');
										});
								}}
							>
								Confirm
							</Button>
						</>
					) : (
						<>
							<Button
								title="Cancel"
								size="medium"
								variant="outlined"
								className={classes.cancelbtn}
								style={{ marginTop: '15px' }}
								disabled={disableButtons}
								onClick={() => {
									setQuoteApprovalDialogOpen(false);
									setQuoteApprovalData({});
									setQuoteApprovalUserResponse('');
								}}
							>
								Cancel
							</Button>
							<Button
								title="Aprove"
								size="medium"
								variant="contained"
								key="Approve"
								className={classes.ActionButtonsQuote}
								style={{ marginTop: '15px', color: '#ffffff !important' }}
								disabled={disableButtons}
								onClick={() => {
									setDisableButtons(true);
									feed
										.updateFeedStatus({
											feedId: opencardData.Id,
											ButtonName: quoteApprovalUserResponse,
											State: {
												Wonum: quoteApprovalData.Wonum,
											},
										})
										.then(resp => {
											//re-load feeds from the server
											fetchStatusFeeds(1);
											setQuoteApprovalDialogOpen(false);
											feedHandleClickClose();
											if (resp != undefined) notifications.addNotification(resp, 'error');
										})
										.catch(() => feedHandleClickClose());
								}}
							>
								Approve
							</Button>
						</>
					)}
				</DialogActions>
			</Dialog>

			<Dialog
				style={{ margin: 'auto', borderRadius: '8px' }}
				open={srStatusDialogOpen}
				onClose={statusHandleClickClose}
				scroll={'paper'}
			>
				<DialogContent>
					<Box display="flex" flexDirection="column" flexGrow={1}>
						<Box>
							<Box style={{ textAlign: 'start' }}>
								<Typography variant="h6" className={classes.openCardTitle}>
									{'This site does not have access to Job Request Chat. Please contact your administrator.'}
								</Typography>
							</Box>
						</Box>
					</Box>
				</DialogContent>
				<DialogActions className={classes.actions2}>
					<Button
						title="Close"
						size="small"
						color="primary"
						onClick={() => {
							statusHandleClickClose();
						}}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
});

export default StatusFeeds;
